import PropTypes from "prop-types"
import { useEffect } from "react"

import Media from "components/ui/media"
import { enableKlarnaCheckout } from "helpers/checkout/checkout_options"

const KlarnaContainer = ({ ...props }) => (
  <Media
    className="tablet:items-end tablet:flex-row tablet:max-w-(--tablet-max-width) desktop:max-w-(--desktop-max-width) tablet:min-h-(--tablet-min-height) min-h-(--base-min-height) flex flex-col items-center"
    style={{
      "--base-min-height": "38px",
      "--desktop-max-width": "280px",
      "--tablet-max-width": "250px",
      "--tablet-min-height": "21px",
    }}
    {...props}
  />
)

const Klarna = ({ price }) => {
  useEffect(() => {
    if (window.Klarna && window.Klarna.OnsiteMessaging) {
      window.Klarna.OnsiteMessaging.refresh()
    }
  }, [price])

  if (!enableKlarnaCheckout() || price <= 0) {
    return null
  }

  const locale = `en-${sl.config.site_country_for_analytics}`

  return (
    <>
      <KlarnaContainer lessThan="tablet">
        <klarna-placement
          data-key="credit-promotion-badge"
          data-locale={locale}
          data-purchase-amount={price}
        />
      </KlarnaContainer>
      <KlarnaContainer greaterThanOrEqual="tablet">
        <klarna-placement
          data-key="credit-promotion-auto-size"
          data-locale={locale}
          data-purchase-amount={price}
        />
      </KlarnaContainer>
    </>
  )
}

Klarna.propTypes = {
  price: PropTypes.number,
}

export default Klarna
